import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { trash } from "react-icons-kit/feather/trash";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import { Pagination } from "rsuite";
import Sidebar from "../components/Sidebar";
import "rsuite/dist/rsuite.min.css";

function Scrapping() {
  const [mediaData, setMediaData] = useState([
    {
      id: 1,
      productName: "Product A",
      storeName: "Store X",
      pincode122002: "Available",
      pincode122001: "Unavailable",
      scrappingDate: "2024-11-25 10:30 AM",
    },
    {
      id: 2,
      productName: "Product B",
      storeName: "Store Y",
      pincode122002: "Unavailable",
      pincode122001: "Available",
      scrappingDate: "2024-11-25 11:00 AM",
    },
    {
      id: 3,
      productName: "Product C",
      storeName: "Store Z",
      pincode122002: "Available",
      pincode122001: "Available",
      scrappingDate: "2024-11-26 09:15 AM",
    },
    {
      id: 4,
      productName: "Product D",
      storeName: "Store W",
      pincode122002: "Unavailable",
      pincode122001: "Unavailable",
      scrappingDate: "2024-11-26 02:45 PM",
    },
    {
      id: 5,
      productName: "Product E",
      storeName: "Store V",
      pincode122002: "Available",
      pincode122001: "Unavailable",
      scrappingDate: "2024-11-27 08:00 AM",
    },
  ]);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [page, setPage] = useState(1);

  const handleDeleteMediaClick = (id) => {
    setMediaData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <h1 className="heading h4 mb-4 fw-bold">Scrapping Details Management</h1>
        <table className="table table-borderless table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Product Name</th>
              <th>Store Name</th>
              <th>Pincode 122002</th>
              <th>Pincode 122001</th>
              <th>Scrapping Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {mediaData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.productName}</td>
                <td>{item.storeName}</td>
                <td>{item.pincode122002}</td>
                <td>{item.pincode122001}</td>
                <td>{item.scrappingDate}</td>
                <td>
                  <button type="button" onClick={() => alert(`Viewing ${item.productName}`)} className="actBtn viewBtn">
                      <Icon className="eye" icon={eye} size={18} />
                      <span className="toolTip">Preview</span>
                  </button>
                  <button
                    onClick={() => alert(`Editing ${item.productName}`)}
                    className="actBtn editBtn"
                  >
                    <Icon className="arrowUpRight" icon={arrowUpRight} size={18} />
                    <span className="toolTip">Preview</span>
                  </button>
                  <button
                    onClick={() => handleDeleteMediaClick(item.id)}
                    className="actBtn delBtn"
                  >
                    <Icon className="trash" icon={trash} size={18} />
                    <span className="toolTip">Delete</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          prev
          next
          first
          last
          size="sm"
          total={mediaData.length}
          limit={itemsPerPage}
          activePage={page}
          onChangePage={(page) => setPage(page)}
          layout={["pager"]}
        />
      </div>
    </div>
  );
}

export default Scrapping;
